import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useProgressiveImg } from './useProgressiveImg.js';
import { ImageBaseComponent, ImageContainer, Icon } from './Image.js';
import { noop } from '@sketch/utils';
import { ReactComponent as ReactComponent$1 } from '@sketch/icons/image-slash-64';
import { ReactComponent } from '@sketch/icons/warning-triangle-64';

const BlurUpImageComponent = styled(ImageBaseComponent) `
  filter: ${({ blur }) => blur && 'blur(10px)'};
`;
const BlurUpImage = ({ alt, className, onError = noop, onLoad = noop, src, width, height, zoomFactor, thumbnail, srcSet, style, }) => {
    const hasSource = !!src;
    const [status, setStatus] = useState(hasSource ? 'loading' : 'no-image');
    const { srcLoaded, blur } = useProgressiveImg(thumbnail !== null && thumbnail !== void 0 ? thumbnail : '', src !== null && src !== void 0 ? src : '');
    useEffect(() => {
        if (!src || !thumbnail) {
            setStatus('no-image');
        }
        else {
            setStatus('loading');
        }
    }, [status, src, thumbnail]);
    const handleImageLoad = (event) => {
        setStatus('successful');
        onLoad(event);
    };
    const handleImageError = () => {
        setStatus('error');
        onError();
    };
    return (jsxs(ImageContainer, Object.assign({ "aria-busy": blur, className: className, width: width, height: height, style: style }, { children: [status === 'error' && (jsx(Icon, { as: ReactComponent, "aria-label": "Error loading" })), status === 'no-image' && jsx(Icon, { as: ReactComponent$1, "aria-label": "No image" }), jsx(BlurUpImageComponent, { alt: alt, src: srcLoaded, onLoad: handleImageLoad, onError: handleImageError, zoomFactor: zoomFactor, blur: blur, srcSet: !blur ? srcSet : undefined, elementtiming: "blur-up-image" })] })));
};

export { BlurUpImage };
